module.exports = __webpack_public_path__ + "static/media/TNCDigital_Web_Cercador_3.90f39ec2.svg";